export default __webpack_public_path__ + "static/media/security.0c422a4c.svg";